<template>
    <div>
        <div>{{ $t('messages.select') }}:</div>
        <div class="flex -space-x-1 flex-wrap relative z-0">
            <label v-for="teacher in filteredTeachers" :key="teacher.id">
                <input type="checkbox" v-model="teacher.is_selected" class="hidden" />

                <img
                    :title="teacher.full_name"
                    :src="teacher.image_path"
                    class="relative z-30 inline-block h-8 w-8 rounded-full ring-2 ring-white"
                    :class="{ 'opacity-50': !teacher.is_selected }"
                    alt=""
                />
            </label>
        </div>
    </div>
    <div class="mt-3">
        <NetworkGraph :edges="info.edges" :nodes="info.nodes" :options="options" />
    </div>
    <div>
        <div>{{ $t('messages.select') }}:</div>
        <div class="flex -space-x-1 flex-wrap relative z-0">
            <label v-for="reward in filteredRewards" :key="reward.id">
                <input type="checkbox" v-model="reward.is_selected" class="hidden" />

                <img
                    :title="reward.title"
                    :src="reward.image_path"
                    class="relative z-30 inline-block h-8 w-8 rounded-lg ring-2 ring-white"
                    :class="[
                        reward.is_negative ? 'bg-red-500' : 'bg-indigo-500',
                        { 'opacity-50': !reward.is_selected },
                    ]"
                    alt=""
                />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NetworkGraphRewardsTeacher',
};
</script>
<script setup>
import { computed, ref } from 'vue';
import NetworkGraph from '@/components/pageSpecific/NetworkGraph.vue';

const props = defineProps({
    teachers: {
        required: true,
        type: Array,
    },
    rewards: {
        required: true,
        type: Array,
    },
});

const filteredTeachers = ref(props.teachers);
const filteredRewards = ref(props.rewards);

const negativeRewards = computed(() => {
    return props.rewards.filter((reward) => reward.is_negative).map((reward) => reward.id);
});

const info = computed(() => {
    const nodes = [];
    const edges = [];
    filteredTeachers.value
        .filter((t) => t.is_selected)
        .forEach((teacher) => {
            nodes.push({
                id: `t_${teacher.id}`,
                shape: 'circularImage',
                image: teacher.image_path,
                group: 'teacher',
                title: teacher.full_name,
                label: teacher.name_or_nickname,
            });

            teacher.rewards.forEach((reward) => {
                let color = negativeRewards.value.includes(reward.reward_id) ? '#ef4444' : '#6366f1';
                edges.push({
                    from: `t_${teacher.id}`,
                    to: `r_${reward.reward_id}`,
                    label: `${reward.qty}`,
                    title: reward.qty,
                    value: reward.qty,
                    color: color,
                });
            });
        });
    filteredRewards.value
        .filter((r) => r.is_selected)
        .forEach((reward) => {
            nodes.push({
                id: `r_${reward.id}`,
                shape: 'image',
                image: reward.image_path,
                group: 'reward',
                label: reward.title,
            });
        });

    return {
        nodes,
        edges,
    };
});

const options = {
    nodes: {
        borderWidth: 4,
        size: 30,
        color: {
            border: '#222222',
            background: '#666666',
        },
    },
    edges: {
        color: {
            color: 'green',
            highlight: '#2ed300',
            hover: '#848484',
            inherit: 'from',
            opacity: 0.4,
        },
        arrows: {
            to: {
                enabled: true,
                scaleFactor: 0.5,
                type: 'arrow',
            },
        },
        scaling: {
            customScalingFunction: function (min, max, total, value) {
                return value / total;
            },
            min: 1,
            max: 25,
        },
        selectionWidth: function (width) {
            return width * 2;
        },
    },
};
</script>
